'use strict';
import {content_margin,nav_width} from '../misc/utilis';
import 'slick-carousel/slick/slick.min';
import 'parsleyjs/dist/parsley.min';
import 'chosen-js/chosen.jquery'
import '../misc/nav';
export default {
  init() {
    var browserClass;

    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window.safari || safari.pushNotification);
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    var isChrome = !!window.chrome && !!window.chrome.webstore;
    //var isBlink = (isChrome || isOpera) && !!window.CSS;

    if(isOpera) {browserClass='opera';}
    else if(isFirefox) {browserClass='firefox';}
    else if(isSafari) {browserClass='safari';}
    else if(isChrome) {browserClass='chrome';}
    else if(isIE) {browserClass='ie';}
    else if(isEdge) {browserClass='edge';}
    $('body').addClass(browserClass);

    $('[data-toggle="tooltip"]').tooltip();

    $("#testimonials_carousel").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
          },
        },
        {
          breakpoint: 590,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            //dots: true
          },
        },
			],
    });
    $( "form.validate" ).submit(function( e ) {
      e.preventDefault();
      var input_token = $(this).find('input.token');
      if($(this).hasClass('antispam')) {
        if(input_token.length && $(this).parsley().isValid()) {
          $(this)[0].submit();
        }
        else if(!input_token.length) {
          $(this).find('.error-robot').show().html('Please select the box above to confirm you are not a robot');
        }
      }
      else {
          if($(this).parsley().isValid()) {
            $(this)[0].submit();
          }
      }
    });

    // $(".country-list").chosen();

    $( "form.validate" ).parsley();

    $('.not-robot').click(function(e){
      e.preventDefault();
      var loaded = $(this).attr('data-loaded');
      if(loaded==='false') return false;
      var token_name = $(this).attr('data-role');
      var url = '/generate_token/'+token_name;
      var _this = $(this);
      _this.parent().find('.error-robot').hide().html('');
      _this.removeClass('fa-square-o').addClass('fa-spinner fa-pulse');
      $.ajax({
        type: 'GET',
        url: url,
        data: url,
        async:true,
        success: function(response){
          _this.attr('data-loaded','false');
          _this.removeClass('fa-spinner fa-pulse not-robot').addClass('fa-check-circle');
          _this.parent().append('<input type="hidden" class="token" name="token_'+token_name+'" value="'+response+'" />');
        },
        error: function(xhr, ajaxOptions, thrownError){
          console.log(xhr);
          console.log(ajaxOptions);
          console.log(thrownError);
        },
      });
    });
    $('#cookie_accepted button').click(function(){
      $(this).parent().slideUp(300);
      $.ajax({
        type: 'POST',
        url: '/',
        data: {cookie_accept:'fF3PgDMt9'},
        async:true,
        success: function(){
        },
        error: function(xhr, ajaxOptions, thrownError){
          console.log(xhr);
          console.log(ajaxOptions);
          console.log(thrownError);
        },
      });
    });
    function escapeRegExp(str) {
        return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    }
    function replaceAll(str, find, replace) {
        return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
    }

    if($('.RealUrl').length) {
        $.ajax({
          type: 'GET',
          url: '/full-site-url/',
          async: true,
          success: function(response){
            $('.RealUrl').each(function(){
               var url = $(this).attr('href');
               if(url.length) {
                  var newUrl = replaceAll(url, '#url#', response);
                  $(this).attr('href',newUrl);
               }
            });
          },
        });
    }
    // savings calculator
    function savings_calculator() {
        var field = $('#savings_calculator input[type="number"]');
        var value = parseFloat(field.val());
        var savings = $('#output span');
        var savingsVal;
        var max = 34050;
        if(value>=0) {
          if(value<5000) {
            savingsVal = 0;
          }
          else if(value>4999 && value<=max) {
              savingsVal = value-value/1.135;
          }
          else {
              savingsVal = max-max/1.135;
          }
          savings.html(savingsVal.toFixed(0)+'.00');
        }
    }
    if($('#savings_calculator').length) {


      $('#savings_calculator input[type="number"]').keyup(function(){
        savings_calculator();
      });
      $('#savings_calculator input[type="number"]').change(function(){
        savings_calculator();
      });
    }
    //share
    $('a.share_it').click(function(e){
       e.preventDefault();
      window.open($(this).attr('href'),'_blank', "top=0, left=0, width=400, height=400");
    });
  },
  finalize() {
    /*
    var Logo = $('#brand_logo svg');
    if(Logo.prop('complete')){
      console.log('SVG rendered');
      content_margin('load');
      nav_width('load');
    }
    */
    window.onload = function() {
      /*
      var logo = ($('#brand_logo svg').length)?$('#brand_logo svg'):$('#brand_logo img');
      var winW = $(window).width();
      var logoW,logoH;
      if(winW>1175) {
        logoW = 260;
        logoH = 111;
      }
      else if(winW<1176 && winW>600) {
        logoW = 220;
        logoH = 89;
      }
      else {
        logoW = 135;
        logoH = 55;
      }
      logo.css({'width':logoW,'height':logoH});
      */
      content_margin('load');
      nav_width('load');
    };

    $(window).on('resize',function(){
      content_margin('resize');
      nav_width('resize');
    });
    //nav_width('load');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js